module.exports = __webpack_public_path__ + "img/beyound.952088b5.png";